import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { nextRequestTab } from "../utils/requestHubTabs";

const NavigationContext = createContext(null);

export function NavigationProvider({
  activeId,
  onNavigate,
  children,
}) {
  const [requestTab, setRequestTabState] = useState("leave");
  const [requestDraft, setRequestDraft] = useState(null);

  const setRequestTab = useCallback((tabId) => {
    if (!tabId) return;
    setRequestTabState(tabId);
  }, []);

  const navigate = useCallback(
    (id, options = {}) => {
      setRequestTabState((current) => nextRequestTab(id, options, current));
      if (Object.prototype.hasOwnProperty.call(options, "draft")) {
        setRequestDraft(options.draft || null);
      }
      onNavigate?.(id, options);
    },
    [onNavigate],
  );

  const clearRequestDraft = useCallback(() => {
    setRequestDraft(null);
  }, []);

  const value = useMemo(
    () => ({
      activeId,
      requestTab,
      requestDraft,
      navigate,
      setRequestTab,
      clearRequestDraft,
    }),
    [activeId, requestTab, requestDraft, navigate, setRequestTab, clearRequestDraft],
  );

  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
}

export function useNavigation() {
  return useContext(NavigationContext);
}

export default NavigationContext;
